import { initialsOf } from '@/lib/format'
import { cx } from './cx'
import styles from './Avatar.module.css'

export type AvatarSize = 34 | 36 | 40 | 44 | 52

export function Avatar({ name, size = 36 }: { name: string; size?: AvatarSize }) {
  return (
    <div
      aria-hidden="true"
      className={cx(styles.avatar, size >= 40 && styles.large)}
      style={{ width: size, height: size }}
    >
      {initialsOf(name)}
    </div>
  )
}
